module.exports = __webpack_public_path__ + "img/bd-mosaic-asn.01f1fbc1.png";